<template>
  <div class="upload-file">
    <div v-if="!oneFlag" class="title"></div>
    <div class="upload-container" :class="{ 'is-multiple': !oneFlag }">
      <base-upload
        :drag="!oneFlag"
        :multiple="!oneFlag"
        :disabled="disabled || cannotUpload"
        :limited-file-suffix="limitedFileSuffix"
        @startUpload="startUpload"
        @uploadFinished="uploadFinished"
        @uploadFailed="uploadFailed"
        class="base-upload"
      >
        <template v-if="fileList.length == 0">
          <div v-if="!oneFlag" class="empty-text" :class="{ 'is-disabled': disabled }">
            将文件拖到此处，或
            <span>点击上传</span>
          </div>
          <div v-else>
            <base-button :disabled="disabled" type="text" class="upload-button">
              <i class="el-icon-plus"></i>
              添加附件
            </base-button>
          </div>
        </template>

        <template v-else>
          <file-row
            v-for="(file, index) in fileList"
            :key="index"
            :file="file"
            @delete="handleRemove(index, file)"
            @click.native.stop="preview(file)"
          ></file-row>
        </template>
        <base-button v-if="!oneFlag" :disabled="disabled" type="text" class="upload-button">
          <i class="el-icon-plus"></i>
          添加附件
        </base-button>
      </base-upload>
    </div>
    <file-preview ref="filePreview"></file-preview>
  </div>
</template>

<script>
import { BaseButton } from "@/components/UIComponents"
import BaseUpload from "@/components/BaseComponents/Upload"
import { getUrlByPath } from "@/utils/uploadFile"
import FileRow from "./FileRow"
import FilePreview from "@/components/BaseComponents/FilePreview"
import { getFileType } from "@/utils/common"

export default {
  name: "form-item-upload-file",
  components: {
    BaseButton,
    BaseUpload,
    FileRow,
    FilePreview
  },
  data() {
    return {
      fileList: [],
      editName: ""
    }
  },
  props: {
    disabled: Boolean,
    oneFlag: Boolean,
    limitedFileSuffix: Array
  },
  computed: {
    cannotUpload() {
      return Boolean(this.oneFlag && this.fileList?.length)
    }
  },
  methods: {
    // 初始化文件列表
    init(files) {
      if (files?.length > 0) {
        this.fileList = files
          .filter(f => f)
          .map(file => {
            return {
              id: file.id,
              name: file.name,
              type: file.type,
              url: getUrlByPath(file.path),
              sizeStr: file.sizeStr,
              tempId: file.tempId // 当多个文件同时上传时,第一个文件上传结束,外部files改变,这里的tempId就丢失了,后续的文件无法正常更新.所以这里要保留tempId
            }
          })
      } else this.fileList = []
    },
    // 文件开始上传
    startUpload(nowFile) {
      nowFile.uploading = true
      this.fileList.push(nowFile)
    },
    // 文件上传完成
    uploadFinished(nowFile) {
      let index = this.fileList.findIndex(i => i.tempId == nowFile.tempId)
      this.fileList.splice(index, 1, nowFile)
      this.emitFiles()
    },
    // 文件上传失败
    uploadFailed(nowFile) {
      if(nowFile?.tempId != undefined){
        let index = this.fileList.findIndex(i => i.tempId == nowFile.tempId)
        this.fileList.splice(index, 1)
      }
    },
    // 修改外部files数组
    emitFiles() {
      this.$emit("updateFiles", this.fileList)
    },
    handleRemove(index, file) {
      this.fileList.splice(index, 1)
      this.emitFiles()
    },
    getType: getFileType,
    // 避免点击触发选择文件
    preview(file) {
      let fileInfo = {
        url: file.url,
        type: this.getType(file.type),
        name: file.name
      }
      this.$refs.filePreview.preview(fileInfo)
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-file {
  position: relative;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  background-color: #fff;
  min-height: 32px;
  .title {
    height: 36px;
    border-bottom: 1px solid $color-font-third;
  }
  .upload-container {
    .upload-button {
      position: absolute;
      top: 0;
      left: 11px;
      font-size: $font-size-main;
      font-weight: unset;
      font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
        "微软雅黑", Arial, sans-serif;
    }
    &.is-multiple {
      ::v-deep {
        .el-upload {
          min-height: 143px;
          &:focus {
            color: #9e9e9e;
          }
          &:hover {
            .empty-text:not(.is-disabled) {
              color: $color-main;
            }
          }
        }
      }
    }
    ::v-deep {
      .el-upload {
        display: flex;
        flex-direction: column;
      }
      .el-upload-dragger {
        flex: auto;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        border: none;
        background-color: transparent;
        overflow: visible;
        position: static;
        .empty-text {
          margin-top: 50px;
          font-size: $font-size-main;
          color: $color-font-third;
        }
      }
    }
  }
}
</style>
